import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  PayMethodExhibitsUpdateRequest,
  PayMethodExhibitsUpdateResponse,
  payMethodExhibitApi,
} from '../../../lib/api/payMethodExhibit';
import {
  PgProviderRoutesFindResponse,
  PgProviderRoutesUpdateRequest,
  PgProviderRoutesUpdateResponse,
  pgProviderRouteApi,
} from '../../../lib/api/pgProviderRoute';
import { payMethodExhibitQuery, pgProviderRouteQuery } from '../queries';

export const useUpdatePgProviderRoutesMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<PgProviderRoutesUpdateResponse, Error, PgProviderRoutesUpdateRequest>({
    mutationFn: (body) => pgProviderRouteApi.updateRoutes(body),
    onSuccess: async (response) => {
      // 🔴 진행 중인 조회를 먼저 끊는다. 저장 전 값을 읽은 GET 이 PUT 성공 뒤에 도착하면
      // 저장 결과를 덮어써 화면이 옛 설정으로 돌아간다. 저장 성공과 함께 초안도 비워지므로
      // 그 상태에서 다시 저장하면 방금 바꾼 규칙을 통째로 되돌리게 된다.
      await queryClient.cancelQueries({ queryKey: pgProviderRouteQuery.list().queryKey });
      queryClient.setQueryData<PgProviderRoutesFindResponse>(pgProviderRouteQuery.list().queryKey, (previous) =>
        previous ? { ...previous, routes: response.routes } : previous,
      );
      void queryClient.invalidateQueries({ queryKey: pgProviderRouteQuery.logs._def });
    },
  });
};

export const useUpdatePayMethodExhibitsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<PayMethodExhibitsUpdateResponse, Error, PayMethodExhibitsUpdateRequest>({
    mutationFn: (body) => payMethodExhibitApi.updatePayMethods(body),
    onSuccess: async (response) => {
      // 라우팅 저장과 같은 이유로 진행 중인 조회를 먼저 끊는다
      await queryClient.cancelQueries({ queryKey: payMethodExhibitQuery.list().queryKey });
      queryClient.setQueryData(payMethodExhibitQuery.list().queryKey, { payMethods: response.payMethods });
      void queryClient.invalidateQueries({ queryKey: pgProviderRouteQuery.logs._def });
    },
  });
};
